// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* Footer.css */
.footer {
  background-color:    var(--secondary-dark);
  /* background-image: linear-gradient(to top, #0f5e67, #367e84, #58a0a1, #7ac3bf, #9de7dd); */
  color: var(--text-dark);
  padding: 4rem 0 1rem;
  text-align: center;
}

.footer-content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section {
  flex: 1 1;
}

.footer-title {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: var(--text-dark);
}

.footer-location {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--text-dark);
}

.footer-subtitle {
  font-size: 1.1rem;
  margin-bottom: 0.75rem;
  color: var(--text-dark);
}

.footer-address {
  text-decoration: none;
  color: var(--text-dark);
}

.footer-button {
  display: inline-block;
  background: #0A2463;
  color: white;
  padding: 0.5rem 1.7rem;
  border-radius: 22px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s;
  letter-spacing: 2px;
  font-size: 0.9rem;
}

.footer-button:hover {
  background: #0A2463;
  transform: translateY(-2px);
}

.footer-phone {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-dark);
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-phone:hover {
  color: #3498db;
}

.footer-copyright {
  padding-top: 1rem;
  border-top: 1px solid  var(--text-dark);
  color: var(--text-dark);
  font-size: 0.9rem;
}

.footer-links {
    display: grid; /* Makes the container a grid container */
    grid-template-columns: repeat(1, 1fr); /* Creates 3 equal-width columns */
    grid-template-rows: auto; /* Rows adjust to content height */
    color: var(--text-dark);
}

.footer-link{
  text-decoration: none;
  color: var(--text-dark);
  letter-spacing: 0.05em;
}

/* Tablet & Desktop */
@media (min-width: 768px) {
  .footer-content {
    flex-direction: row;
    text-align: left;
  }

  .footer-location {
    justify-content: flex-start;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.css"],"names":[],"mappings":";EACE,eAAe;AACjB;EACE,0CAA0C;EAC1C,4FAA4F;EAC5F,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;IACI,aAAa,EAAE,yCAAyC;IACxD,qCAAqC,EAAE,kCAAkC;IACzE,wBAAwB,EAAE,kCAAkC;IAC5D,uBAAuB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["\n  /* Footer.css */\n.footer {\n  background-color:    var(--secondary-dark);\n  /* background-image: linear-gradient(to top, #0f5e67, #367e84, #58a0a1, #7ac3bf, #9de7dd); */\n  color: var(--text-dark);\n  padding: 4rem 0 1rem;\n  text-align: center;\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n.footer-section {\n  flex: 1;\n}\n\n.footer-title {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  color: var(--text-dark);\n}\n\n.footer-location {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--text-dark);\n}\n\n.footer-subtitle {\n  font-size: 1.1rem;\n  margin-bottom: 0.75rem;\n  color: var(--text-dark);\n}\n\n.footer-address {\n  text-decoration: none;\n  color: var(--text-dark);\n}\n\n.footer-button {\n  display: inline-block;\n  background: #0A2463;\n  color: white;\n  padding: 0.5rem 1.7rem;\n  border-radius: 22px;\n  text-decoration: none;\n  font-weight: 500;\n  transition: all 0.3s;\n  letter-spacing: 2px;\n  font-size: 0.9rem;\n}\n\n.footer-button:hover {\n  background: #0A2463;\n  transform: translateY(-2px);\n}\n\n.footer-phone {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--text-dark);\n  font-size: 0.9rem;\n  text-decoration: none;\n  transition: color 0.3s;\n}\n\n.footer-phone:hover {\n  color: #3498db;\n}\n\n.footer-copyright {\n  padding-top: 1rem;\n  border-top: 1px solid  var(--text-dark);\n  color: var(--text-dark);\n  font-size: 0.9rem;\n}\n\n.footer-links {\n    display: grid; /* Makes the container a grid container */\n    grid-template-columns: repeat(1, 1fr); /* Creates 3 equal-width columns */\n    grid-template-rows: auto; /* Rows adjust to content height */\n    color: var(--text-dark);\n}\n\n.footer-link{\n  text-decoration: none;\n  color: var(--text-dark);\n  letter-spacing: 0.05em;\n}\n\n/* Tablet & Desktop */\n@media (min-width: 768px) {\n  .footer-content {\n    flex-direction: row;\n    text-align: left;\n  }\n\n  .footer-location {\n    justify-content: flex-start;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
